import Styled from "styled-components"
// import background from '../../public/background.jpg'

export const StyledMainScreen = Styled.div`
    background-color: black;
    background-image: url('background2.png');
    background-repeat: repeat-x;
    background-size: 960px 800px;
    height: 100%;
`;

export const StyledControls = Styled.div`
    display: flex;
    justify-content: center;
`;

export const StyledLogo = Styled.div`
    background-image: url('duckLOGO.png');
    height: 30px;
    width: 210px;
`;

export const StyledLogoContainer = Styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const StyledText = Styled.div`
    margin-top: 5rem;
    font-size: 1.5rem;
    color: white;
    /* font-family: fantasy; */
    font-family: joystix, serif;
    max-width: 75%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
`
